import React, { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../context/UserContext";
import {
  acceptTransaction,
  fetchAdminTransactions,
  fetchRejected,
  rejectTransaction,
} from "../api/api";
import HeaderQC from "./HeaderQC";
import RejectPopup from "./Popup";

const PanelD = () => {
  const { user } = useContext(UserContext);
  const [transactions, setTransactions] = useState([]);
  const [rejectedTransactions, setRejectedTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const tableRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedTxnId, setSelectedTxnId] = useState(null);

  const openRejectPopup = (txnId) => {
    setSelectedTxnId(txnId);
    setShowPopup(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      try {
        const data = await fetchAdminTransactions(user);
        if (Array.isArray(data)) {
          setTransactions(data);
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    const fetchRejects = async () => {
      if (!user) return;
      const rejects = await fetchRejected(user);
      if (Array.isArray(rejects)) setRejectedTransactions(rejects);
    };

    fetchData();
    fetchRejects();
  }, [user]);

  const [loading, setLoading] = useState(false);

  const handleApprove = (transaction_id) => {
    return async () => {
      try {
        setLoading(true); // Show "Please wait..."

        window.scrollTo(0, 0);

        const result = await acceptTransaction(transaction_id, user);

        setTransactions((prevTransactions) =>
          prevTransactions.filter(
            (txn) => txn.transaction_id !== transaction_id
          )
        );

        alert(result || "Transaction Approved");
        window.location.reload();
      } catch (error) {
        console.error("Failed:", error);
        alert("Failed to approve transaction");
      } finally {
        setLoading(false); // Hide message after completion
      }
    };
  };

  const handleReject = async (transaction_id, remarks) => {
    try {
      console.log(transaction_id, remarks);
      const result = await rejectTransaction(transaction_id, user, remarks);

      setTransactions((prevTransactions) =>
        prevTransactions.filter((txn) => txn.transaction_id !== transaction_id)
      );

      window.location.reload();
      alert(result || "Transaction Rejected");
    } catch (error) {
      console.error("Error rejecting transaction:", error);
      alert("Failed to reject transaction");
    }
  };

  const handleView = (id) => {
    window.location.href = `/view-transaction/${id}`;
  };

  const handleScroll = () => {
    tableRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    window.location.href = "/login";
  };

  const filteredTransactions = transactions.filter((txn) =>
    txn.transactionId?.toString().includes(searchTerm.trim())
  );

  return (
    <div className="min-h-screen bg-light">
      {/* Header */}

      <HeaderQC />

      <div className="row-md-3">
        <div className="col d-flex align-items-center justify-content-between p-4 ">
          <div className="d-flex gap-3 w-100">
            <div className="card flex-fill rounded-4 shadow-sm border-0 bg-warning text-white">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-0">Pending Transactions</p>
                    <h5 className="fw-bold mb-0">{transactions.length}</h5>
                  </div>
                  <i className="bi bi-clock-history fs-3"></i>
                </div>
              </div>
            </div>

            <div
              onClick={handleScroll}
              className="card flex-fill rounded-4 shadow-sm border-0 bg-danger text-white"
              style={{ cursor: "pointer" }}
            >
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-0">Rejected Transactions</p>
                    <h5 className="fw-bold mb-0">
                      {rejectedTransactions.length}
                    </h5>
                  </div>
                  <i className="bi bi-x-circle fs-3" title="Rejected"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      {loading && (
        <div style={{ backgroundColor: "#1DA5B1" }}
        className="fixed top-0 left-1/2 transform -translate-x-1/2 text-white px-4 py-2 rounded-md shadow-lg">
          Processing... Please wait.
        </div>
      )}
      <div className="container-fluid">
        <div className="card border-0 shadow-sm rounded-4">
          <div className="card-header bg-white border-0 py-1">
            <div className="row align-items-center">
              <div className="col">
                <h4 className="mb-0">Pending Transactions</h4>
              </div>
              <div className="col-auto">
                <div className="input-group">
                  <span className="input-group-text border-0 bg-light">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-0 bg-light"
                    placeholder="Search transactions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="border-0 px-4">Transaction ID</th>
                    <th className="border-0">Problem Comment</th>
                    <th className="border-0">Team A remarks</th>
                    <th className="border-0">Team B remarks</th>
                    <th className="border-0">Team C remarks</th>
                    <th className="border-0 px-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTransactions.map((txn) => (
                    <tr key={txn.transaction_id}>
                      <td className="px-4">
                        <span className="fw-medium">#{txn.transactionId}</span>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.problemComment || "No comment"}
                        </small>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.teamA_remark || "No comment"}
                        </small>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.teamB_remark || "No comment"}
                        </small>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.teamC_remark || "No comment"}
                        </small>
                      </td>

                      <td>
                        <div className="container py-2 d-flex gap-4">
                          <button
                            className="btn btn-primary btn-sm rounded-pill px-3 fw-bold shadow-lg animate-hover"
                            onClick={() => handleView(txn.transactionId)}
                            style={{
                              transition: "0.3s",
                              transform: "scale(1)",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.transform = "scale(1.05)")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          >
                            <i className="bi bi-eye fs-5 text-white" />
                          </button>

                          <button
                            className="btn btn-md btn-success rounded-pill px-3 fw-bold shadow-lg animate-hover"
                            onClick={handleApprove(txn.transactionId)}
                            style={{
                              transition: "0.3s",
                              transform: "scale(1)",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.transform = "scale(1.05)")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          >
                            Approve
                          </button>

                          <button
                            className="btn btn-danger btn-md rounded-pill px-3 fw-bold shadow-lg animate-hover"
                            onClick={() => openRejectPopup(txn.transactionId)}
                            style={{
                              transition: "0.3s",
                              transform: "scale(1)",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.transform = "scale(1.05)")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          >
                            Reject
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* approved table */}
      <div className="container-fluid py-4">
        <div className="card border-0 shadow-sm rounded-4">
          <div className="card-header bg-white border-0 py-1">
            <div className="row align-items-center">
              <div className="col">
                <h4 ref={tableRef} className="mb-0">
                  Rejected Transactions
                </h4>
              </div>
              <div className="col-auto">
                <div className="input-group">
                  <span className="input-group-text border-0 bg-light">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-0 bg-light"
                    placeholder="Search transactions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="border-0 px-4">Transaction ID</th>
                    <th className="border-0">Team A remark</th>
                    <th className="border-0">Team B remark</th>
                    <th className="border-0">Team C remark</th>
                    <th className="border-0">Team D remark</th>
                    <th className="border-0 px-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rejectedTransactions.map((txn) => (
                    <tr key={txn.transaction_id}>
                      <td className="px-4">
                        <span className="fw-medium">#{txn.transaction_id}</span>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.team_a_remark || "No remark"}
                        </small>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.team_b_remark || "No remark"}
                        </small>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.team_c_remark || "No remark"}
                        </small>
                      </td>

                      <td>
                        <small className="text-muted">
                          {txn.team_d_remark || "No remark"}
                        </small>
                      </td>

                      <td>
                        <div className="container py-2 d-flex gap-4">
                          <button
                            className="btn btn-primary btn-sm rounded-pill px-3 fw-bold shadow-lg animate-hover"
                            onClick={() => handleView(txn.transaction_id)}
                            style={{
                              transition: "0.3s",
                              transform: "scale(1)",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.transform = "scale(1.05)")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          >
                            <i className="bi bi-eye fs-5 text-white" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {showPopup && (
        <RejectPopup
          show={showPopup}
          onCancel={() => setShowPopup(false)}
          onReject={(txnId, remarks) => {
            handleReject(txnId, remarks);
            setShowPopup(false); 
          }}
          transaction_id={selectedTxnId}
        />
      )}
    </div>
  );
};

export default PanelD;
